import { jsx as _jsx } from "react/jsx-runtime";
var factor = 100;
export var ECGInfoFooter = function (_a) {
    var time = _a.time, amplitude = _a.amplitude;
    var informationText = "".concat(time * factor, " mm/s, ").concat(amplitude * factor, " mm/mV");
    return (_jsx("div", { className: "e-flex e-justify-start e-w-10/12", children: _jsx("span", { className: "e-text-3xl e-font-medium e-m-2", children: informationText }) }));
};
//# sourceMappingURL=ECGInfoFooter.js.map